"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLink = exports.isLinkProps = exports.Link = void 0;
var Link_1 = require("@reactionable/core/lib/ui/link/Link");
Object.defineProperty(exports, "Link", { enumerable: true, get: function () { return Link_1.Link; } });
Object.defineProperty(exports, "isLinkProps", { enumerable: true, get: function () { return Link_1.isLinkProps; } });
Object.defineProperty(exports, "useLink", { enumerable: true, get: function () { return Link_1.useLink; } });
//# sourceMappingURL=Link.js.map